{
	"app_sidebar": {
		"menu": {
			"theme": "Tema"
		},
		"theme": {
			"dark": "Scuro",
			"light": "Chiaro",
			"system": "Sistema"
		},
		"user_menu": {
			"language": "Lingua",
			"language_no_results": "Nessuna lingua trovata",
			"language_search_placeholder": "Cerca lingua..."
		}
	},
	"async_pickers": {
		"empty": "Nessun risultato",
		"error": "Caricamento delle opzioni non riuscito",
		"prompt": "Scrivi per cercare",
		"selected_count_one": "1 selezionato",
		"selected_count_other": "{{count}} selezionati"
	},
	"avatar": {
		"add_photo": "Aggiungi foto",
		"change_photo": "Cambia foto",
		"invalid_type": "Scegli un'immagine JPEG, PNG o WebP.",
		"remove_photo": "Rimuovi foto",
		"too_large": "Scegli un'immagine più piccola di 5 MB.",
		"upload_error": "Impossibile caricare la foto."
	},
	"breadcrumb": {
		"more": "Altri livelli"
	},
	"color_picker": {
		"alpha": "Opacità",
		"alpha_short": "O",
		"clear": "Cancella colore",
		"eyedropper": "Preleva dallo schermo",
		"format": {
			"hex": "HEX",
			"hsl": "HSL",
			"oklch": "OKLCH",
			"rgb": "RGB"
		},
		"hue": "Tonalità",
		"hue_short": "T",
		"placeholder": "Scegli un colore",
		"presets": "Predefiniti",
		"validation": {
			"invalid_color": "Inserisci un colore OKLCH valido"
		}
	},
	"combobox": {
		"clear": "Cancella selezione",
		"open_list": "Apri elenco"
	},
	"copy_button": {
		"copied": "Copiato",
		"copy": "Copia"
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Adatta larghezza colonna",
			"clear_sort": "Rimuovi ordinamento",
			"hide_column": "Nascondi colonna",
			"no_pin": "Nessun blocco",
			"pin_column": "Blocca colonna",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"sort_asc": "Ordina crescente",
			"sort_desc": "Ordina decrescente",
			"trigger": "Opzioni colonna {{column}}"
		},
		"column_settings": {
			"drag_handle": "Riordina colonna",
			"no_results": "Nessuna colonna trovata",
			"pin_column": "Blocca {{column}}",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"reset": "Ripristina",
			"search_placeholder": "Cerca colonne...",
			"show_all": "Mostra tutte",
			"toggle_visibility": "Mostra/nascondi {{column}}",
			"trigger": "Colonne",
			"unpin": "Sblocca"
		},
		"error": "Caricamento dei dati non riuscito",
		"loading_more": "Caricamento...",
		"no_results": "Nessun risultato",
		"pagination": {
			"go_to_page": "Vai a pagina {{page}}",
			"more_pages": "Altre pagine",
			"next": "Successivo",
			"previous": "Precedente",
			"rows_per_page": "Righe per pagina"
		},
		"resize_column": "Ridimensiona colonna",
		"select_all": "Seleziona tutte le righe",
		"select_row": "Seleziona riga",
		"sort_by": "Ordina per {{column}}"
	},
	"date_input": {
		"open_calendar": "Apri calendario",
		"validation": {
			"disabled_date": "Questa data non è disponibile",
			"invalid_date": "Inserisci una data valida",
			"max_date": "La data deve essere uguale o precedente a {{maxDate}}",
			"min_date": "La data deve essere uguale o successiva a {{minDate}}",
			"range": "La data deve essere compresa tra {{minDate}} e {{maxDate}}"
		}
	},
	"date_picker": {
		"cancel": "Annulla",
		"description": "Scegli una data dal calendario",
		"presets": {
			"last_30_days": "Ultimi 30 giorni",
			"last_7_days": "Ultimi 7 giorni",
			"last_month": "Mese scorso",
			"last_year": "Anno scorso",
			"this_month": "Questo mese",
			"this_week": "Questa settimana",
			"this_year": "Quest'anno"
		},
		"submit": "Conferma",
		"title": "Seleziona data"
	},
	"desktop_only": {
		"description": "Al momento l'app è ottimizzata per l'uso da desktop. Apri il link dal tuo computer per accedere al tuo account.",
		"title": "Passa al computer per continuare"
	},
	"dialog": {
		"close": "Chiudi"
	},
	"drop_zone": {
		"accepted_formats": "Accettati: {{formats}} · fino a {{size}}",
		"choose_files": "Scegli i file",
		"drag_and_drop_files": "Trascina e rilascia i file qui",
		"drop_files_here": "Rilascia i file qui"
	},
	"filters_sidebar": {
		"applied_filters": "Filtri applicati",
		"apply_filters": "Applica filtri",
		"available_filters": "Filtri disponibili",
		"remove_filters_one": "Rimuovi filtro",
		"remove_filters_other": "Rimuovi tutti i filtri",
		"title": "Filtri"
	},
	"http_errors": {
		"admin_already_verified": "Questo account risulta già attivato: vai al login.",
		"admin_email_already_exists": "Esiste già un admin con questa email.",
		"admin_forbidden": "Non hai i permessi per eseguire questa azione amministrativa.",
		"admin_invite_token_invalid": "Il link di invito è scaduto o è già stato usato: chiedi un nuovo invito al tuo amministratore.",
		"admin_reset_password_session_missing": "La sessione di reimpostazione password amministrativa non è presente.",
		"admin_reset_password_token_invalid": "Il token di reimpostazione password amministrativa non è valido o è scaduto.",
		"admin_session_not_found": "Sessione amministrativa non trovata.",
		"admin_target_user_not_found": "L'utente amministrativo selezionato non è stato trovato.",
		"admin_user_already_deleted": "Questo utente amministrativo è già stato eliminato.",
		"admin_user_not_found": "Account non trovato: contatta un amministratore.",
		"anonymous_sign_in_disabled": "L'accesso anonimo è disabilitato.",
		"anonymous_user_cannot_change_password": "Gli utenti anonimi non possono modificare la password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Gli utenti anonimi non possono accedere di nuovo in modo anonimo.",
		"api_key_invalid": "La chiave API non è valida.",
		"apple_android_ott_invalid": "Il token di accesso Apple Android non è valido.",
		"apple_android_sign_in_failed": "Accesso con Apple Android non riuscito.",
		"apple_mobile_deep_link_not_allowed": "I link di accesso Apple mobile non sono consentiti.",
		"apple_mobile_ott_invalid": "Il token di accesso Apple mobile non è valido.",
		"apple_mobile_sign_in_failed": "Accesso con Apple mobile non riuscito.",
		"asset_corrupted": "Non è stato possibile elaborare questo file: caricalo di nuovo.",
		"asset_mime_type_not_allowed": "Questo tipo di file non è consentito.",
		"asset_not_found": "File non trovato.",
		"asset_ownership_error": "Non hai accesso a questo file.",
		"asset_size_too_large": "Questo file è troppo grande.",
		"asset_storage_missing": "L'archiviazione dei file non è disponibile.",
		"auth_credentials_missing": "Effettua l'accesso prima di continuare.",
		"auth_csrf_invalid": "Il token di sicurezza della sessione non è valido: ricarica e riprova.",
		"auth_email_not_found": "Nessun account trovato con questo indirizzo email.",
		"auth_jwt_invalid": "La sessione di accesso non è valida o è scaduta: effettua di nuovo l'accesso.",
		"auth_session_issue_failed": "Non è stato possibile completare l'accesso: riprova.",
		"auth_token_invalid": "La sessione di accesso non è valida o è scaduta: ricomincia.",
		"backoffice_admin_deleted": "Questo account amministratore è stato eliminato.",
		"backoffice_admin_disabled": "Questo account amministratore è disabilitato: contatta un amministratore.",
		"backoffice_admin_not_found": "Account amministratore non trovato.",
		"backoffice_auth_credentials_missing": "Effettua l'accesso come admin prima di continuare.",
		"backoffice_auth_token_invalid": "La sessione di accesso non è valida o è scaduta: ricomincia.",
		"backoffice_challenge_not_found": "Sfida di autenticazione admin non trovata.",
		"backoffice_change_password_otp_invalid": "Il codice via email non è valido: riprova.",
		"backoffice_change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password admin.",
		"backoffice_change_password_totp_invalid": "Il codice dell'app di autenticazione non è valido: riprova.",
		"backoffice_csrf_invalid": "Il token di sicurezza della sessione admin non è valido: ricarica e riprova.",
		"backoffice_disable_two_factor_method_not_available": "Non è disponibile alcun metodo per disabilitare l'autenticazione a due fattori per questo account admin.",
		"backoffice_disable_two_factor_otp_invalid": "Il codice via email non è valido: riprova.",
		"backoffice_disable_two_factor_otp_unavailable": "I codici via email non sono disponibili per disabilitare l'autenticazione a due fattori per questo account admin.",
		"backoffice_disable_two_factor_passkey_invalid": "Verifica con passkey non riuscita: riprova.",
		"backoffice_disable_two_factor_recovery_code_invalid": "Il codice di recupero non è valido: riprova.",
		"backoffice_disable_two_factor_totp_invalid": "Il codice dell'app di autenticazione non è valido: riprova.",
		"backoffice_email_already_in_use": "Esiste già un account admin con questa email.",
		"backoffice_email_change_token_invalid": "La sessione di modifica dell'email admin non è valida o è scaduta.",
		"backoffice_email_otp_token_invalid": "La sessione di verifica è scaduta: richiedi un nuovo codice.",
		"backoffice_failed_to_verify_registration": "Impossibile verificare la registrazione della passkey admin.",
		"backoffice_invalid_code": "Il codice non è valido.",
		"backoffice_invalid_email_or_password": "L'email o la password non sono validi.",
		"backoffice_invalid_password": "La password non è valida.",
		"backoffice_invite_invalid": "Questo invito admin non è valido o è scaduto.",
		"backoffice_jwt_invalid": "La sessione admin non è valida o è scaduta: effettua di nuovo l'accesso.",
		"backoffice_mfa_challenge_invalid": "La sessione di verifica è scaduta: effettua di nuovo l'accesso.",
		"backoffice_mfa_challenge_required_for_change_password": "Verifica la tua identità prima di modificare questa password admin.",
		"backoffice_mfa_device_limit_reached": "Questo account admin ha raggiunto il limite di dispositivi per l'autenticazione a due fattori.",
		"backoffice_mfa_email_otp_not_available": "I codici di verifica via email non sono disponibili per questo account.",
		"backoffice_mfa_enrollment_expired": "La configurazione dell'autenticazione a due fattori è scaduta: ricomincia.",
		"backoffice_mfa_invalid_backup_code": "Il codice di backup non è valido: riprova.",
		"backoffice_mfa_invalid_email_otp": "Il codice via email non è valido: riprova.",
		"backoffice_mfa_invalid_passkey": "Verifica con passkey non riuscita: riprova.",
		"backoffice_mfa_invalid_totp_code": "Il codice dell'app di autenticazione non è valido: riprova.",
		"backoffice_mfa_not_enabled": "L'autenticazione a due fattori non è abilitata per questo account admin.",
		"backoffice_mfa_passkey_not_available": "La verifica con passkey non è disponibile per questo account admin.",
		"backoffice_new_email_same_as_current": "La nuova email admin corrisponde a quella attuale.",
		"backoffice_no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password admin.",
		"backoffice_passkey_authentication_failed": "Autenticazione admin con passkey non riuscita.",
		"backoffice_passkey_limit_reached": "Questo account admin ha raggiunto il limite di passkey.",
		"backoffice_passkey_not_found": "Passkey admin non trovata.",
		"backoffice_reset_password_session_missing": "La sessione di reimpostazione password amministrativa non è presente.",
		"backoffice_reset_password_token_invalid": "Il token di reimpostazione password amministrativa non è valido o è scaduto.",
		"backoffice_self_edit_forbidden": "Non puoi modificare qui il tuo account admin.",
		"backoffice_session_expired": "La sessione admin è scaduta: effettua di nuovo l'accesso.",
		"backoffice_session_invalid": "La sessione admin non è più valida: effettua di nuovo l'accesso.",
		"backoffice_session_issue_failed": "Non è stato possibile completare l'accesso: riprova.",
		"backoffice_social_not_registered": "Nessun account admin è registrato per questo accesso social.",
		"backoffice_totp_authenticator_not_found": "App di autenticazione admin non trovata.",
		"backoffice_you_are_not_allowed_to_register_this_passkey": "Non sei autorizzato a registrare questa passkey admin.",
		"backup_codes_not_enabled": "I codici di backup non sono abilitati per questo account.",
		"blacklisted_email_domain": "Questo dominio email non è consentito.",
		"broadcast_recipients_not_found": "Nessuno dei destinatari selezionati è stato trovato.",
		"challenge_not_found": "Sfida di autenticazione non trovata.",
		"change_password_otp_invalid": "Il codice via email non è valido: riprova.",
		"change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password.",
		"change_password_totp_invalid": "Il codice dell'app di autenticazione non è valido: riprova.",
		"conversation_not_found": "Conversazione non trovata.",
		"credential_account_not_found": "Account con credenziali non trovato.",
		"csrf_token_mismatch": "Il token di sicurezza della sessione non è aggiornato: ricarica e riprova.",
		"default": "Ops! Qualcosa è andato storto.",
		"delete_anonymous_user_disabled": "L'eliminazione degli utenti anonimi è disabilitata.",
		"disable_two_factor_method_not_available": "Non è disponibile alcun metodo per disabilitare l'autenticazione a due fattori per questo account.",
		"disable_two_factor_otp_invalid": "Il codice via email non è valido: riprova.",
		"disable_two_factor_otp_unavailable": "I codici via email non sono disponibili per disabilitare l'autenticazione a due fattori per questo account.",
		"disable_two_factor_passkey_invalid": "Verifica con passkey non riuscita: riprova.",
		"disable_two_factor_recovery_code_invalid": "Il codice di recupero non è valido: riprova.",
		"disable_two_factor_totp_invalid": "Il codice dell'app di autenticazione non è valido: riprova.",
		"email_already_in_use": "Esiste già un account con questa email.",
		"email_already_verified": "Questo indirizzo email è già verificato.",
		"email_can_not_be_updated": "Questo indirizzo email non può essere aggiornato.",
		"email_change_token_invalid": "La sessione di modifica dell'email non è valida o è scaduta.",
		"email_domain_not_allowed": "Questo dominio email non è abilitato per gli admin.",
		"email_mismatch": "L'indirizzo email non corrisponde.",
		"email_not_verified": "Questo indirizzo email non è verificato.",
		"email_otp_token_invalid": "La sessione di verifica è scaduta: richiedi un nuovo codice.",
		"email_password_disabled": "L'accesso con email e password è disabilitato.",
		"email_password_sign_up_disabled": "La registrazione con email e password è disabilitata.",
		"expires_in_is_too_large": "La durata di scadenza è troppo lunga.",
		"expires_in_is_too_small": "La durata di scadenza è troppo breve.",
		"export_not_found": "Export non trovato.",
		"export_too_large_for_sync": "Questo export è troppo grande per il download diretto: usa auto o email quando pronto.",
		"failed_to_create_session": "Impossibile creare la sessione.",
		"failed_to_create_user": "Impossibile creare l'utente.",
		"failed_to_delete_anonymous_user": "Impossibile eliminare l'utente anonimo.",
		"failed_to_get_user_info": "Impossibile caricare le informazioni utente.",
		"failed_to_update_passkey": "Impossibile aggiornare la passkey.",
		"failed_to_verify_registration": "Impossibile verificare la registrazione.",
		"forbidden": "Non hai i permessi per eseguire questa azione.",
		"id_token_not_supported": "Questo token di identità non è supportato.",
		"idempotency_in_flight": "La stessa richiesta è ancora in elaborazione: aspetta un momento e riprova.",
		"idempotency_key_required": "La richiesta è partita senza la chiave di idempotenza: ricarica la pagina e riprova.",
		"idempotency_key_reused": "Quella chiave di idempotenza era già stata usata per un'altra richiesta: ricomincia l'operazione.",
		"invalid_backup_code": "Il codice di backup non è valido.",
		"invalid_code": "Il codice non è valido.",
		"invalid_delete_account_otp": "Il codice di eliminazione account non è valido.",
		"invalid_email": "L'indirizzo email non è valido.",
		"invalid_email_or_password": "Email o password non validi.",
		"invalid_metadata_type": "Il tipo dei metadati non è valido.",
		"invalid_name_length": "La lunghezza del nome non è valida.",
		"invalid_otp": "La password monouso non è valida.",
		"invalid_password": "La password non è valida.",
		"invalid_prefix_length": "La lunghezza del prefisso non è valida.",
		"invalid_remaining": "Il valore rimanente non è valido.",
		"invalid_token": "Il token non è valido o è scaduto.",
		"invalid_two_factor_cookie": "Il cookie di autenticazione a due fattori non è valido.",
		"key_not_found": "Chiave API non trovata.",
		"last_social_account_without_email": "Aggiungi un indirizzo email prima di scollegare l'ultimo account social.",
		"llm_not_configured": "Il servizio AI non è disponibile al momento.",
		"llm_unavailable": "Il servizio AI è temporaneamente non disponibile: riprova più tardi.",
		"maintenance_mode": "Il servizio è temporaneamente in manutenzione.",
		"message_not_editable": "Questo messaggio non può più essere modificato.",
		"message_not_found": "Messaggio non trovato.",
		"metadata_disabled": "I metadati sono disabilitati per questa chiave API.",
		"name_required": "Il nome è obbligatorio.",
		"new_email_same_as_current": "La nuova email corrisponde a quella attuale.",
		"no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password.",
		"no_values_to_update": "Non ci sono valori da aggiornare.",
		"node_purged": "Questo elemento è in eliminazione definitiva e non si può più ripristinare.",
		"oidc_callback_exchange_failed": "Non è stato possibile completare l'accesso: riprova.",
		"oidc_callback_state_invalid": "Questo link di accesso non è più valido: ricomincia dalla pagina di accesso.",
		"organization_login_unavailable": "Questa organizzazione non è disponibile per l'accesso: controlla il nome e riprova.",
		"organization_slug_taken": "Questo indirizzo è già usato da un’altra organizzazione.",
		"otp_expired": "La password monouso è scaduta.",
		"otp_has_expired": "La password monouso è scaduta: richiedi un nuovo codice.",
		"otp_issuance_throttled": "Troppe richieste di codice: attendi prima di richiederne uno nuovo.",
		"otp_not_enabled": "Le password monouso non sono abilitate.",
		"password_too_long": "La password è troppo lunga.",
		"password_too_short": "La password è troppo breve.",
		"permission_denied": "Il tuo account ha effettuato l'accesso, ma non dispone dei permessi necessari per visualizzare questa pagina.",
		"provider_not_found": "Provider di autenticazione non trovato.",
		"purge_not_allowed": "Solo chi possiede ciò che vuoi distruggere può eliminarlo definitivamente. Chiedilo a chi lo possiede, oppure ripristinalo.",
		"reset_password_disabled": "La reimpostazione della password è disabilitata.",
		"reset_password_session_missing": "La sessione di reimpostazione password non è presente.",
		"reset_password_token_invalid": "Il token di reimpostazione password non è valido o è scaduto.",
		"resolve_user_required": "È necessario risolvere un utente prima di continuare.",
		"resolved_user_invalid": "L'utente risolto non è valido.",
		"server_only_property": "Questa proprietà può essere modificata solo dal server.",
		"session_expired": "La sessione è scaduta: effettua di nuovo l'accesso.",
		"session_invalid": "La sessione non è più valida: effettua di nuovo l'accesso.",
		"session_not_found": "Sessione non trovata.",
		"session_not_fresh": "Esegui nuovamente l'autenticazione prima di continuare.",
		"session_required": "È richiesta una sessione valida.",
		"sign_up_session_missing": "La sessione di registrazione non è presente.",
		"too_many_attempts": "Troppi tentativi: riprova più tardi.",
		"too_many_attempts_request_new_code": "Troppi tentativi: richiedi un nuovo codice.",
		"two_factor_not_enabled": "L'autenticazione a due fattori non è abilitata.",
		"unable_to_create_session": "Impossibile creare una nuova sessione.",
		"unauthorized": "Non hai effettuato l'accesso: effettua l'accesso per continuare.",
		"unauthorized_session": "Questa sessione non è autorizzata.",
		"user_already_exists_use_another_email": "Esiste già un utente con questa email: usa un altro indirizzo email.",
		"user_already_has_provider_linked": "Questo utente ha già quel provider collegato.",
		"user_banned": "Questo account utente è stato bannato.",
		"user_deleted": "Questo account utente è stato eliminato.",
		"user_email_not_found": "Nessun utente trovato con questo indirizzo email.",
		"user_is_not_anonymous": "Questo utente non è anonimo.",
		"user_not_found": "Utente non trovato.",
		"validation_error": "Alcuni dei dati inseriti non sono validi.",
		"verification_email_not_enabled": "Le email di verifica non sono abilitate.",
		"verify_email_session_missing": "La sessione di verifica email non è presente.",
		"verify_email_token_invalid": "Il token di verifica email non è valido o è scaduto.",
		"you_are_not_allowed_to_register_this_passkey": "Non sei autorizzato a registrare questa passkey."
	},
	"infinite_virtual_list": {
		"empty": "Nessun risultato",
		"error": "Caricamento dei dati non riuscito"
	},
	"inline_filter_date": {
		"from": "Da {{date}}",
		"to": "Fino al {{date}}"
	},
	"inline_filters": {
		"clear": "Rimuovi filtro",
		"clear_all": "Rimuovi tutto",
		"confirm": "Conferma",
		"scroll_next": "Scorri i filtri a destra",
		"scroll_previous": "Scorri i filtri a sinistra"
	},
	"input_bytes": {
		"unit": "Unità"
	},
	"input_currency": {
		"empty": "Nessuna valuta trovata",
		"search": "Cerca valuta...",
		"select_currency": "Seleziona valuta",
		"validation": {
			"invalid_amount": "Inserisci un importo valido"
		}
	},
	"input_password": {
		"hide": "Nascondi password",
		"show": "Mostra password"
	},
	"input_phone": {
		"empty": "Nessun paese trovato",
		"search": "Cerca paese...",
		"select_country": "Seleziona paese",
		"validation": {
			"invalid_phone_number": "Inserisci un numero di telefono valido"
		}
	},
	"list_input_search": {
		"clear": "Cancella ricerca"
	},
	"pagination": {
		"more_pages": "Altre pagine",
		"next_page": "Vai alla pagina successiva",
		"previous_page": "Vai alla pagina precedente"
	},
	"passkey": {
		"already_registered": "Esiste già una passkey per questo account su questo dispositivo.",
		"cancelled": "Nessuna passkey è stata usata. Riprova o accedi con un altro metodo.",
		"not_supported": "Questo dispositivo non può creare una passkey con le impostazioni richieste.",
		"security": "Il browser ha bloccato la richiesta passkey per questo sito. Di solito significa che l'indirizzo del sito non corrisponde alla configurazione passkey del server."
	},
	"password_requirements": {
		"met": "rispettato",
		"unmet": "non rispettato"
	},
	"query_breadcrumbs": {
		"error": "Errore",
		"no_data": "Dettaglio"
	},
	"quota_field": {
		"required": "Serve una quota.",
		"unlimited": "Nessun limite"
	},
	"refresh_button": {
		"refresh": "Aggiorna",
		"updated_at": "Ultimo aggiornamento: {{time}}"
	},
	"rich_text_editor": {
		"blocks": {
			"blockquote": "Citazione",
			"bulleted_list": "Elenco puntato",
			"code_block": "Blocco di codice",
			"h1": "Titolo 1",
			"h2": "Titolo 2",
			"h3": "Titolo 3",
			"numbered_list": "Elenco numerato"
		},
		"code_block_languages": {
			"bash": "Bash",
			"css": "CSS",
			"html": "HTML",
			"js": "JavaScript",
			"json": "JSON",
			"md": "Markdown",
			"plain": "Testo semplice",
			"python": "Python",
			"ts": "TypeScript"
		},
		"editor_label": "Editor di testo ricco",
		"mention": {
			"empty": "Nessun risultato"
		},
		"slash": {
			"empty": "Nessun comando corrisponde"
		},
		"toolbar": {
			"bold": "Grassetto",
			"code": "Codice inline",
			"italic": "Corsivo",
			"spoiler": "Spoiler",
			"strikethrough": "Barrato",
			"underline": "Sottolineato"
		}
	},
	"sheet": {
		"close": "Chiudi"
	},
	"sidebar": {
		"toggle": "Mostra o nascondi la barra laterale"
	},
	"two_factor": {
		"backup_description": "Inserisci uno dei tuoi codici di backup monouso.",
		"backup_label": "Codice di backup",
		"verify": "Verifica"
	},
	"two_factor_device_picker": {
		"device_label": "Dispositivo authenticator",
		"device_unnamed": "Dispositivo senza nome"
	},
	"validation": {
		"otp_length": "Il codice deve essere di 6 cifre."
	}
}
